module.exports = "https://bicocca-network.servercdn.it/static/img/lens.svg?2bd866da860fc8b6259c003b6aa765b9";